
import barba from '@barba/core';
import Swiper from 'swiper';

export default class{

	constructor(){

        barba.hooks.beforeOnce((data) => {
            this.aboutSldier()
            this.imageSldier()
            this.gallerySlider()

        })
        barba.hooks.leave((data) => {
            window.removeEventListener("resize",this.resize);
        })

        barba.hooks.after((data) => {
            this.aboutSldier()
            this.imageSldier()
            this.gallerySlider()
        });
        
    }
    
    aboutSldier(){
        new Swiper ('#js-index__slider',{
            loop: true,
            effect :'fade',
            speed:3000,
            allowTouchMove :false,
            simulateTouch:false,
            autoplay: {
                delay: 4000
            },
            pagination: {
                el: '#js-index__slider .swiper-pagination',
                // dynamicBullets: true,
                renderBullet: function(index, className) {
                    return '<span class="' + className + ' swiper-pagination-bullet--svg-animation"><svg width="40" height="40" viewBox="0 0 40 40"><circle class="svg__circle" cx="20" cy="20" r="20" fill="none" stroke-width="1"></circle><circle class="svg__circle-inner" cx="20" cy="20" r="3"></circle></svg></span>';
                },
            },
        })
    }
    
    gallerySlider(){
        // const gallery_thumbnails = document.querySelectorAll('.gallery-slider-thumbnails a');
        const gallerythumbnails = new Swiper('.js-gallery__thumbnails', {
            slidesPerView: 6,
            spaceBetween: 10,
            allowTouchMove: false
        });
        const gallerySlider = new Swiper('.js-gallery__slider', {
            loop: true,
            speed:400,
            easing:"linear",
            loopAdditionalSlides : 5,
            slidesPerView: 'auto',
            spaceBetween: 20,
            simulateTouch:true,
            centeredSlides: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                576: {
                    slidesPerView: 'auto',
                    spaceBetween:  40,
                }
            },
            thumbs: {
                swiper: gallerythumbnails,
            }
        });
        // const galleryThumbnailAddEvent = (el,i) => {
        //     el.addEventListener('click',function(e){
        //         e.preventDefault();
        //         gallerySlider.slideTo(i+1);
        //     })
        // }
        // for(var i = 0; i <  gallery_thumbnails.length; i++){
        //     galleryThumbnailAddEvent( gallery_thumbnails[i],i);
        // }
    }
    imageSldier(){
        this.imageSliderItem = new Swiper('.js-image__slider', {
            loop: true,
            speed:3000,
            easing:"linear",
            loopAdditionalSlides : 5,
            slidesPerView: 2,
            spaceBetween: 0,
            allowTouchMove:false,
            simulateTouch:false,
            centeredSlides: false,
            autoplay: {
                delay: 0,
            },
            freeMode: true,

            breakpoints: {
                
                575: {
                    slidesPerView: 3,
                },
                767: {
                    slidesPerView: 4,
                }
            },
        })
            
        window.addEventListener("resize",this.resize);
    }

    resize(){
        const imageSliderEl = document.querySelector('.js-image__slider')
        if(imageSliderEl){
            if(this.imageSliderItem){
                this.imageSliderItem.autoplay.start()
            }
        }
    }
}